import { render, staticRenderFns } from "./CurrencyItem.vue?vue&type=template&id=e86afdbc&scoped=true"
import script from "./CurrencyItem.vue?vue&type=script&lang=js"
export * from "./CurrencyItem.vue?vue&type=script&lang=js"
import style0 from "./CurrencyItem.vue?vue&type=style&index=0&id=e86afdbc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e86afdbc",
  null
  
)

export default component.exports